export { default as NCode, codeProps } from './src/Code';
